export default __webpack_public_path__ + "static/media/user-one.40c69d6b.png";